// extracted by mini-css-extract-plugin
module.exports = {"container":"LoyaltySoftGate_container__e0UZf","btns":"LoyaltySoftGate_btns__Wc9cB","logoWrapper":"LoyaltySoftGate_logoWrapper__o3Ucu"};